<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2"><span class="text_">Christine R. Regas started writing short playlets for Brownies to act, culminating in a full-length ‘Panto rhyme’ (i.e., pantomime in rhyme). Later, she was asked to write </span><i class="calibre1">Children’s Look In</i><span class="text_"> for her church newspaper, which is where an early part of </span><i class="calibre1">The Secret Sign</i><span class="text_"> began. This continued for several years and three or four articles were also published in </span><i class="calibre1">Together with Children</i><span class="text_">, a Christian resource magazine now out of print. She has also written articles for adults on the church paper and some sketches to be acted out in church.</span></p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?5ec0e858